























































































import TitleBar from '@/components/Elements/TitleBar.vue'

import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapState, mapActions } from 'vuex';

import { STORE_KEY, store } from './_store';
import moment from 'moment';

@Component({
  computed: {
    ...mapState(STORE_KEY, [
      'loading', 'loaded', 'fatalError',

      'items',
    ]),
    ...mapGetters(STORE_KEY, [
      'rows'
    ])
  },
  methods: {
    ...mapActions(STORE_KEY, [
      'setReportOptions', 'exportDataAsXLSX'
    ])
  },
  components: {
    TitleBar
  }
})
export default class WarehouseByDateReport extends Vue {
  warehouse_id: any = null;
  targetDates: any[] = [];

  get titleStack () {
    return [
      'Отчеты',
      'Отчет по остаткам на складе (на дату)'
    ]
  }

  localFilter = {
    dZoneGroups: null,
    targetDates: [new Date(), new Date()],
  }

  get defaultSort() {
    return [this.$route.query.sortField || 'product_name', this.$route.query.sortDirection || 'asc']
  }

  onSort(field: string, direction: string) {
    console.log('onSort', field, direction)
    this.$router.replace({
      query: {
        ...this.$route.query, sortField: field, sortDirection: direction
      }
    })
  }

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }

  public mounted() {
    if (this.$route.query.warehouse_id) {
      this.warehouse_id = this.$route.query.warehouse_id
    }

    // @ts-ignore
    this.targetDates = (this.$route.query && this.$route.query.since) ? [moment(this.$route.query.since).toDate(), moment(this.$route.query.until).toDate()] : [new Date(), new Date()];

    this.handleParamsChange();
  }

  onWarehouseChange(warehouse_id: string) {
    if (warehouse_id) {
      this.$router.replace({
        query: { ...this.$route.query, warehouse_id }
      })
    }
  }

  onDatesChange(dates: any) {
    console.log('onDatesChange', dates)
    this.$router.replace({
      query: {
        ...this.$route.query,
        since: moment(dates[0]).format('YYYY-MM-DD'),
        until: moment(dates[1]).format('YYYY-MM-DD'),
      }
    })
  }

  // ---------------------------------------------------------------------------

  @Watch('$route.query')
  public handleParamsChange() {
    if (this.$route.query && this.$route.query.warehouse_id) {
      this.$store.dispatch(`${STORE_KEY}/loadData`, this.$route.query);
    }
  }

}
